import { render, staticRenderFns } from "./SliderContent.vue?vue&type=template&id=59341d54&scoped=true&"
import script from "./SliderContent.vue?vue&type=script&lang=js&"
export * from "./SliderContent.vue?vue&type=script&lang=js&"
import style0 from "./SliderContent.vue?vue&type=style&index=0&id=59341d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59341d54",
  null
  
)

export default component.exports